<template>
  <Can action="store" subject="contract">
    <div data-component-group="contract-dialog" data-component="add-new">
      <dialog-add
        icon="receipt"
        :title="$t('add_new_contract')"
        is-fullscreen
        :is-on="true"
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-contract-add-new
            :contract="{}"
            class="elevation-1"
            :is-loading="isAddingContract"
            :on-cancel="onCancel"
            :on-submit="createContract"
          />
        </template>
      </dialog-add>
    </div>
  </Can>
</template>

<script>
  export default {
    data() {
      return {
        isAddingContract: false,
      };
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'contracts' });
      },
      createContract(contract) {
        this.isAddingContract = true;

        return this.$store
          .dispatch('contracts/create', contract)
          .then((res) => {
            this.$router.push({ name: 'contracts', query: { status: 'success' } });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isAddingContract = false;
          });
      },
    },
  };
</script>
